import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogUERBaseCostConstructionTypesGql } from '../createOrEditUerQueries';

export const useCatalogUERConstructionTypes = (catalogUniqueId = '') => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            catalogUniqueId,
        }),
        [catalogUniqueId],
    );

    const [
        catalogUERBaseCostConstructionTypesData,
        catalogUERBaseCostConstructionTypesStatus,
        ,
        baseCostConstructionTypesRequest,
    ] = useRequest({
        requestId: 'catalogUERBaseCostConstructionTypes',
        query: catalogUERBaseCostConstructionTypesGql,
        variables,
        withEffect: Boolean(catalogUniqueId),
    });

    const catalogConstructionTypesRequest = useCallback(() => {
        dispatch(baseCostConstructionTypesRequest(variables));
    }, [baseCostConstructionTypesRequest, dispatch, variables]);

    return {
        catalogUERConstructionTypesItems:
            catalogUERBaseCostConstructionTypesData?.catalogUERBaseCostConstructionTypes?.items,
        catalogUERBaseCostConstructionTypesStatus,
        catalogConstructionTypesRequest,
    };
};
